export default "__VITE_ASSET__0bd6635a__"